import classNames from 'classnames';

export const getWrapperClassNames = (
    isCssVariationMobile,
) =>
    classNames({
        'odf-space-inner-left-m odf-space-inner-right-m': !isCssVariationMobile,
        'prisma-responsive-space-horizontal': isCssVariationMobile,
        'odf-position-relative odf-bg-base': true,
        'odf-space-inner-top-m  odf-space-inner-bottom-m': true,
        'od-flights-manager-wrapper': true,
    });

export const getTripTypeWrapperClassNames = (isCssVariationMobile) =>
    classNames({
        'odf-space-outer-bottom-m': true,
        'odf-space-outer-top-s': isCssVariationMobile,
    });

export const getSecondaryButtonClassNames = (isCssVariationMobile) =>
    classNames({
        'odf-space-outer-top-s': !isCssVariationMobile,
        'odf-space-outer-top-m': isCssVariationMobile,
    });
